/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import FormField from "@ingka/form-field";
import Button from "@ingka/button";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useTranslate } from "../../../translate";
import ValidationErrorMessage from "../../ValidationErrorMessage";
import SSRIcon from "@ingka/ssr-icon";
import infoIcon from "@ingka/ssr-icon/paths/information-circle";

import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/modal/style.scss";
import "@ingka/focus/style.scss";
import "@ingka/svg-icon/style.scss";
import "./OTPPrompt.scss";
let countDownInterval;

const convertNumberToMinSec = (totalSeconds) => {
  const doubleDigit = (sec) => {
    return sec.toString().padStart(2, "0");
  };
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${doubleDigit(minutes)}:${doubleDigit(seconds)}`;
};

export const OTPPrompt = ({
  visible,
  mobileNumber,
  onVerifyOtpClick,
  onResendOtpClick,
  errorMessage,
  otpFieldOnChange,
}) => {
  const i18n = useTranslate();
  const { t } = i18n;
  const initialValues = { otp: "" };
  const countDownMax = 59;
  const countDown = useRef(countDownMax);
  const [countDownVal, setCountDownVal] = useState(countDownMax);

  useEffect(() => {
    startCoundDown();
    return () => {
      clearInterval(countDownInterval);
    };
  }, []);

  const startCoundDown = () => {
    countDownInterval = setInterval(() => {
      if (countDown.current <= 0) {
        clearInterval(countDownInterval);
        return;
      }
      countDown.current -= 1;
      setCountDownVal(countDown.current);
    }, 1000);
  };

  const validationSchema = Yup.object({
    otp: Yup.string().required(
      t("walletLogin.OTPPrompt.OtpFieldValidation.required.message")
    ),
  });

  const handleVerifyClick = ({ event, otp }) => {
    onVerifyOtpClick({ otp });
  };

  const handleResendOtpClick = () => {
    if (countDownVal <= 0) {
      onResendOtpClick();
      countDown.current = countDownMax;
      startCoundDown();
    }
  };
  return (
    <div className="otp-prompt-container">
      <div
        visible={visible}
        escapable={false}
        focusLockProps={{ disabled: true }}
        handleCloseBtn={function noRefCheck() {}}
      >
        <div aria-label="Accessibility header for a otp-prompt">
          <div className="prompt-container">
            <div className="otp-prompt-title-container">
              <div className="otp-prompt-title">
                {t("walletLogin.OTPPrompt.title")}
              </div>
              <div className="resend-otp">
                <span
                  className="resend-otp--btn"
                  onClick={handleResendOtpClick}
                >
                  {t("walletLogin.OTPPrompt.resendButton.text")}{" "}
                  {countDownVal > 0
                    ? "(" + convertNumberToMinSec(countDownVal) + ")"
                    : ""}
                </span>
              </div>
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                setTimeout(() => {
                  alert(JSON.stringify(values, null, 2));
                }, 500);
              }}
            >
              {({
                values,
                dirty,
                isValid,
                errors,
                touched,
                handleChange,
                handleBlur,
                resetForm,
              }) => {
                return (
                  <Form className="form">
                    <FormField className="form-field otp-field-container">
                      <div className="input-field label-wrapper label-wrapper--text-input">
                        <label
                          htmlFor="otp-field"
                          className=""
                          title="Enter OTP"
                        ></label>
                        <div className="input-field__wrapper">
                          <input
                            type="text"
                            id="otp"
                            name="otp"
                            autoComplete="off"
                            autoFocus={true}
                            value={values.otp}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            maxLength={6}
                            onBlur={handleBlur}
                          />
                          <span className="input-field__border"></span>
                        </div>
                      </div>
                      <div
                        className={
                          "errors-holder " +
                          (errorMessage && errorMessage.length)
                            ? "response-error"
                            : ""
                        }
                      >
                        <div className="error-message-container-validation">
                          <ErrorMessage
                            name="otp"
                            component={ValidationErrorMessage}
                          />
                        </div>
                        {errorMessage && errorMessage.length && (
                          <div className="error-message-container">
                            <SSRIcon className="center-icon" paths={infoIcon} />
                            {errorMessage}
                          </div>
                        )}
                      </div>
                    </FormField>

                    <div className="verify-btn-container">
                      <Button
                        className="verify-btn"
                        type="emphasised"
                        text={t("walletLogin.OTPPrompt.submitButton.text")}
                        onClick={(e) =>
                          handleVerifyClick({
                            event: e,
                            otp: values.otp,
                          })
                        }
                        disabled={!(dirty && isValid)}
                      />
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};
